import { z } from 'zod/v4';
import { AlternativeContactType } from '../../customers/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { channelsSchema, contactChannelSchema } from './channel-shape.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    types: z.array(z.enum(AlternativeContactType)).optional(),
});
const itemSchema = z.object({
    name: z.string(),
    type: z.enum(AlternativeContactType).nullable(),
    isContact: z.boolean(),
    description: z.string().nullable(),
    channels: channelsSchema(contactChannelSchema),
});
const facetsSchema = z.object({
    byType: z.record(z.enum(AlternativeContactType), z.number().int()),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchContactPersonsTool = {
    name: ToolName.SearchContactPersons,
    category: ToolCategory.CaseInfo,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "List alternative contact persons attached to this case (lawyers, guardians, spouses, employers, etc.). Read-only — MVP heavy tools only message the debtor or the creditor, not alternative contacts. The contact's `type` (lawyer, guardian, etc.) is the strongest signal for how to reason about each relationship.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-contact-persons.js.map